import React, { FC, useEffect, useState } from "react";
import { ReactSVG } from "react-svg";
import { SearchOutlined } from "@ant-design/icons";
import { Dropdown } from "antd";
import { useDispatch } from "react-redux";
import { ENCRYPT_TOKEN } from "reducers/authReducer";

import {
  CreateNewPageModal,
  UserStatusModal,
  CallLogsModal,
  CallBoxModal,
  ExecutiveModal,
  PeopleModal,
  AnalyticsSummaryModal,
  AnalyticsSummaryModalTemp,
  IoTAlertTableModal,
  PeopleListModal,
  ProjectListModal,
} from "../../Modals";
import { PAGE_TYPES } from "utils/PageTypes";
import AnalyticsVideoModal from "components/Modals/AnalyticsVideoModal";
import { useSelector } from "react-redux";
import { RootState } from "reducers/rootReducer";
import { popupCenter } from "utils/appUtil";
import { SocketTopics } from "constants/enums";
import { getUserSubscriptionTopic } from "hooks/MQTTConstants";

const SideBar: FC<{ socket?: ISocket; params: DashboardParams }> = ({
  socket,
  params,
}) => {
  const { screens, setScreens, setFirstCADVisible } = params;
  const [isCreateNewPageModalVisible, setIsCreateNewPageModalVisible] =
    useState<CreateNewPageModelObj>({
      visible: false,
      type: PAGE_TYPES.REGULAR,
    });
  const [isUserStatusModalVisible, setIsUserStatusModalVisible] =
    useState<boolean>(false);
  const [isCallLogsModalVisible, setIsCallLogsModalVisible] =
    useState<boolean>(false);
  const [isCallBoxModalVisible, setIsCallBoxModalVisible] =
    useState<boolean>(false);
  const [createBroadcasePageModalVisible, setCreateBroadcasePageModalVisible] =
    useState<boolean>(false);
  const [analyticsVideoModalDisplayed, setAnalyticsVideoModal] =
    useState<boolean>(false);
  const [executiveModalDisplayed, setExecutiveModalDisplayed] =
    useState<boolean>(false);
  const [peopleModalDisplayed, setPeopleModalDisplayed] =
    useState<boolean>(false);
  const [projectModalDisplayed, setProjectModalDisplayed] =
    useState<boolean>(false);
  const [isAlertTableModalVisible, setIsAlertTableModalVisible] =
    useState<boolean>(false);
  const [currentLocation, setCurrentLocation] = useState<CurrentLocation>();
  const { page_group, projects } = useSelector(
    (state: RootState) => state.dashboard
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (page_group)
      setIsCreateNewPageModalVisible({ visible: true, type: PAGE_TYPES.GROUP });
  }, [page_group]);

  const getCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        console.log("set current location", position);
        setCurrentLocation({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  };

  useEffect(() => {
    getCurrentLocation();
  }, []);

  useEffect(() => {
    console.log("current location updated");
  }, [currentLocation]);

  const menu = (
    <ul className="user-dropdown">
      <li
        onClick={
          () => {
            // setFirstCADVisible && setFirstCADVisible(true);

            // popupCenter(
            //   `${
            //     process.env.REACT_APP_SHARED_URI
            //   }/911?userId=${localStorage.getItem(
            //     "RID"
            //   )}&connectionId=${localStorage.getItem("CID")}`,
            //   "First CAD",
            //   window.innerWidth * 0.7,
            //   window.innerHeight * 0.9
            // );


            dispatch(
              ENCRYPT_TOKEN({
                data: {
                  payload: JSON.stringify({
                    userId: localStorage.getItem("RID"),
                    connectionId: `${localStorage.getItem("CID")}`,
                    // cudbServiceId: projects?.userServiceId,
                  }),
                },
                callback: (token) => {
                  // console.log("encrrypted token here", token);
                  window.open(`${process.env.REACT_APP_SHARED_URI}/911?token=${token.encryptedPayload}`, '_blank');
                  // console.log('url here', `${process.env.REACT_APP_ADMIN_API}?token=${token.encryptedPayload}`)
                },
              })
            );


          }
          // setScreens({
          //   ...screens,
          //   ridePanel: true,
          //   cadType: "Nine11",
          //   message: false,
          // })
        }
      >
        <span className="ml-2">First</span>
      </li>

      <li
        onClick={() => {
          // setFirstCADVisible && setFirstCADVisible(true);

          popupCenter(
            `${
              process.env.REACT_APP_SHARED_URI
            }/cpc?userId=${localStorage.getItem(
              "RID"
            )}&connectionId=${localStorage.getItem("CID")}`,
            "First CAD",
            window.innerWidth * 0.7,
            window.innerHeight * 0.9
          );
        }}
      >
        <span className="ml-2">Event creator</span>
      </li>

      <li
        onClick={() => {
          // setFirstCADVisible && setFirstCADVisible(true);

          setProjectModalDisplayed(true);
        }}
      >
        <span className="ml-2">Project event creator</span>
      </li>

      <li
        onClick={() => {
          // setFirstCADVisible && setFirstCADVisible(true);

          // popupCenter(
          //   `${
          //     process.env.REACT_APP_SHARED_URI
          //   }/instore?userId=${localStorage.getItem(
          //     "RID"
          //   )}&connectionId=${localStorage.getItem("CID")}`,
          //   "First CAD",
          //   window.innerWidth * 0.7,
          //   window.innerHeight * 0.9
          // );

          window.open(
            `${
              process.env.REACT_APP_SHARED_URI
            }/instore?userId=${localStorage.getItem(
              "RID"
            )}&connectionId=${localStorage.getItem("CID")}1`,
            "_blank"
          );
        }}
      >
        <span className="ml-2">Instore</span>
      </li>

      {/* <li
        onClick={() => {
          // setFirstCADVisible && setFirstCADVisible(true);

          // popupCenter(
          //   `${
          //     process.env.REACT_APP_SHARED_URI
          //   }/ride?userId=${localStorage.getItem(
          //     "RID"
          //   )}&connectionId=${localStorage.getItem("CID")}`,
          //   "Ride CAD",
          //   window.innerWidth * 0.7,
          //   window.innerHeight * 0.9
          // );

          // window.open(`${
          //   process.env.REACT_APP_SHARED_URI
          // }/ride?userId=${localStorage.getItem(
          //   "RID"
          // )}&connectionId=${localStorage.getItem("CID")}0`, "_blank");

          dispatch({
            type: "SET_SELECTED_ITEM",
            payload: { pageId: undefined },
          });
          setScreens({
            ...screens,
            iframe: true,
            iframeUrl: `${
              process.env.REACT_APP_SHARED_URI
            }/ride?userId=${localStorage.getItem(
              "RID"
            )}&connectionId=${localStorage.getItem("CID")}0`,
          });
        }}
      >
        <span className="ml-2">Ride</span>
      </li> */}

      <li
        onClick={() => {
          // setFirstCADVisible && setFirstCADVisible(true);

          // popupCenter(
          //   `${
          //     process.env.REACT_APP_SHARED_URI
          //   }/call-center?userId=${localStorage.getItem(
          //     "RID"
          //   )}&connectionId=${localStorage.getItem("CID")}`,
          //   "Ride CAD",
          //   window.innerWidth * 0.7,
          //   window.innerHeight * 0.9
          // );

          // dispatch(
          //   ENCRYPT_TOKEN({
          //     data: {
          //       payload: JSON.stringify({
          //         userId: localStorage.getItem("RID"),
          //         connectionId: `${localStorage.getItem("CID")}0`,
          //       }),
          //     },
          //     callback: (token) => {
          //       console.log("encrrypted token here", token);

          //       window.open(
          //         `${process.env.REACT_APP_SHARED_URI}/call-center?token=${token.encryptedPayload}`,
          //         "_blank"
          //       );
          //     },
          //   })
          // );

          window.open(
            `${
              process.env.REACT_APP_SHARED_URI
            }/call-center?userId=${localStorage.getItem(
              "RID"
            )}&connectionId=${localStorage.getItem("CID")}0`,
            "_blank"
          );
        }}
      >
        <span className="ml-2">Call center</span>
      </li>

      <li
        onClick={() => {
          // setFirstCADVisible && setFirstCADVisible(true);


          // window.open(
          //   `${
          //     process.env.REACT_APP_SHARED_URI
          //   }/calendar?userId=${localStorage.getItem(
          //     "RID"
          //   )}&connectionId=${localStorage.getItem("CID")}`,
          //   "_blank"
          // );

          dispatch(
            ENCRYPT_TOKEN({
              data: {
                payload: JSON.stringify({
                  userId: localStorage.getItem("RID"),
                  connectionId: `${localStorage.getItem("CID")}`,
                  // cudbServiceId: projects?.userServiceId,
                }),
              },
              callback: (token) => {
                // console.log("encrrypted token here", token);
                window.open(`${process.env.REACT_APP_SHARED_URI}/calendar?token=${token.encryptedPayload}`, '_blank');
                // console.log('url here', `${process.env.REACT_APP_ADMIN_API}?token=${token.encryptedPayload}`)
              },
            })
          );

        }}
      >
        <span className="ml-2">Calendar</span>
      </li>

      {/* <li
        onClick={() =>
          setScreens({
            ...screens,
            ridePanel: true,
            cadType: "RxPanel",
            message: false,
          })
        }
      >
        <span className="ml-2">RX</span>
      </li>
      <li
        onClick={() =>
          setScreens({
            ...screens,
            ridePanel: true,
            cadType: "RideDispatch",
            message: false,
          })
        }
      >
        <span className="ml-2">Ride</span>
      </li>
      <li>
        <span className="ml-2">MedRide</span>
      </li>
      <li>
        <span className="ml-2">SafeHands</span>
      </li>
      <li
        onClick={() =>
          setScreens({
            ...screens,
            ridePanel: true,
            cadType: "Logistics",
            message: false,
          })
        }
      >
        <span className="ml-2">Logistics</span>
      </li>
      <li
        onClick={() =>
          setScreens({
            ...screens,
            ridePanel: true,
            cadType: "Store",
            message: false,
          })
        }
      >
        <span className="ml-2">Store</span>
      </li>
      <li
        onClick={() =>
          setScreens({
            ...screens,
            ridePanel: true,
            cadType: "ContactTracing",
            message: false,
          })
        }
      >
        <span className="ml-2">Contact Tracing</span>
      </li>
      <li>
        <span className="ml-2">Door</span>
      </li> */}
    </ul>
  );

  const rideMenu = (
    <ul className="user-dropdown">
      <li
        onClick={() => {
          dispatch({
            type: "SET_SELECTED_ITEM",
            payload: { pageId: undefined },
          });
          setScreens({
            ...screens,
            iframe: true,
            iframeUrl: `${
              process.env.REACT_APP_SHARED_URI
            }/ride?userId=${localStorage.getItem(
              "RID"
            )}&connectionId=${localStorage.getItem("CID")}0`,
          });
        }}
      >
        <span className="ml-2">Dispatch</span>
      </li>

      <li
        onClick={() => {
          dispatch({
            type: "SET_SELECTED_ITEM",
            payload: { pageId: undefined },
          });
          setScreens({
            ...screens,
            iframe: true,
            iframeUrl: `${
              process.env.REACT_APP_SHARED_URI
            }/ride-dashboard?userId=${localStorage.getItem(
              "RID"
            )}&connectionId=${localStorage.getItem("CID")}1`,
          });
        }}
      >
        <span className="ml-2">Dispatch + dashboard</span>
      </li>

      <li
        onClick={() => {
          window.open(
            `${
              process.env.REACT_APP_SHARED_URI
            }/ride2?userId=${localStorage.getItem(
              "RID"
            )}&connectionId=${localStorage.getItem("CID")}2`,
            "_blank"
          );
        }}
      >
        <span className="ml-2">Dispatch new window</span>
      </li>
    </ul>
  );

  // const callCenterMenu = (
  //   <ul className="user-dropdown">
  //     <li onClick={() => setIsCallBoxModalVisible(true)}>
  //       <span className="ml-2">Call</span>
  //     </li>
  //     <li onClick={() => setIsCallLogsModalVisible(true)}>
  //       <span className="ml-2">Logs</span>
  //     </li>
  //     <li onClick={() => setIsUserStatusModalVisible(true)}>
  //       <span className="ml-2">Status</span>
  //     </li>
  //   </ul>
  // );

  const dashboardMenu = (
    <ul className="user-dropdown">
      <li
        onClick={() => {
          dispatch({
            type: "SET_SELECTED_ITEM",
            payload: { pageId: undefined },
          });
          setScreens({
            ...screens,
            iframe: true,
            iframeUrl: `${
              process.env.REACT_APP_SHARED_URI
            }/dashboard?userId=${localStorage.getItem(
              "RID"
            )}&connectionId=${localStorage.getItem("CID")}10`,
          });
        }}
      >
        <span className="ml-2">Embedded</span>
      </li>
      <li
        onClick={() => {
          window.open(
            `${
              process.env.REACT_APP_SHARED_URI
            }/dashboard?userId=${localStorage.getItem(
              "RID"
            )}&connectionId=${localStorage.getItem("CID")}11`,
            "_blank"
          );
        }}
      >
        <span className="ml-2">New window</span>
      </li>
    </ul>
  );

  return (
    <div className="sidebar">
      <ul>
        <li className="mb-5">
          <ReactSVG
            src="/images/plus-icon.svg"
            onClick={() =>
              setIsCreateNewPageModalVisible({
                visible: true,
                type: PAGE_TYPES.REGULAR,
              })
            }
          />
          <p>New</p>
          {/* <p>Create page</p> */}
          {isCreateNewPageModalVisible.visible && (
            <CreateNewPageModal
              // page_group={page_group}
              currentLocation={currentLocation}
              socket={socket}
              isModalVisible={isCreateNewPageModalVisible}
              setIsModalVisible={setIsCreateNewPageModalVisible}
            />
          )}
        </li>
        <li>
          <ReactSVG
            src="/images/broadcast-icon.svg"
            onClick={() =>
              setIsCreateNewPageModalVisible({
                visible: true,
                type: PAGE_TYPES.BROADCAST,
              })
            }
          />
          <p>Broadcast</p>
        </li>
        <li>
          <Dropdown overlay={menu} placement="bottomRight" trigger={["click"]}>
            <ReactSVG src="/images/dispatcher-icon.svg" />
          </Dropdown>
          <p>Event</p>
        </li>
        {/* <li>
          <ReactSVG
            src="/images/emergency-icon.svg"
            onClick={() => setIsAlertTableModalVisible(true)}
          />
          <p>Assist</p>
        </li> */}
        <li
          onClick={() => {
            dispatch(
              ENCRYPT_TOKEN({
                data: {
                  payload: JSON.stringify({
                    userId: localStorage.getItem("RID"),
                    connectionId: `${localStorage.getItem("CID")}`,
                    // cudbServiceId: projects?.userServiceId,
                  }),
                },
                callback: (token) => {
                  // console.log("encrrypted token here", token);
                  window.open(`${process.env.REACT_APP_SHARED_URI}/ride2?token=${token.encryptedPayload}`, '_blank');
                  // console.log('url here', `${process.env.REACT_APP_ADMIN_API}?token=${token.encryptedPayload}`)
                },
              })
            );
          }}
        >
          {/* <Dropdown
            overlay={rideMenu}
            placement="bottomRight"
            trigger={["click"]}
          > */}
          {/* <ReactSVG src="/images/car-icon.svg" /> */}
          <ReactSVG
            src="/images/ride-dispatch-icon.svg"
            className="settings-icon"
          />
          {/* </Dropdown> */}
          <p>Ride</p>
        </li>
        <li>
          <Dropdown
            overlay={dashboardMenu}
            placement="bottomRight"
            trigger={["click"]}
          >
            <ReactSVG src="/images/desktop-icon.svg" />
          </Dropdown>
          <p>Dashboard</p>
        </li>
        <li
          onClick={() => {
            setPeopleModalDisplayed(true);
          }}
        >
          <ReactSVG src="/images/community-icon.svg" />
          <p>Friends</p>
        </li>
        <li
          onClick={() => {
            setAnalyticsVideoModal(true);
          }}
        >
          <ReactSVG src="/images/media-icon.svg" />
          <p>Video</p>
        </li>

        <li
          onClick={() => {
            // console.log("project cliecked", projects);
            dispatch(
              ENCRYPT_TOKEN({
                data: {
                  payload: JSON.stringify({
                    userId: localStorage.getItem("RID"),
                    connectionId: `${localStorage.getItem("CID")}`,
                    cudbServiceId: projects?.userServiceId,
                    configUserId: projects?.adminUserId,
                  }),
                },
                callback: (token) => {
                  // console.log("encrrypted token here", token);
                  window.location.href = `${process.env.REACT_APP_ADMIN_API}?token=${token.encryptedPayload}`;
                  // console.log('url here', `${process.env.REACT_APP_ADMIN_API}?token=${token.encryptedPayload}`)
                },
              })
            );
          }}
        >
          <ReactSVG src="/images/setting-icon.svg" className="settings-icon" />
          <p>Admin</p>
        </li>
      </ul>

      {isUserStatusModalVisible && (
        <UserStatusModal
          isModalVisible={isUserStatusModalVisible}
          setIsModalVisible={setIsUserStatusModalVisible}
        />
      )}
      {isCallLogsModalVisible && (
        <CallLogsModal
          isModalVisible={isCallLogsModalVisible}
          setIsModalVisible={setIsCallLogsModalVisible}
        />
      )}
      {isCallBoxModalVisible && (
        <CallBoxModal
          isModalVisible={isCallBoxModalVisible}
          setIsModalVisible={setIsCallBoxModalVisible}
        />
      )}
      {executiveModalDisplayed && (
        <ExecutiveModal onClose={() => setExecutiveModalDisplayed(false)} />
      )}
      {/*{executiveModalDisplayed && <AnalyticsSummaryModalTemp onClose={() => setExecutiveModalDisplayed(false)} /> }*/}
      {analyticsVideoModalDisplayed && (
        <AnalyticsVideoModal onClose={() => setAnalyticsVideoModal(false)} />
      )}
      {peopleModalDisplayed && (
        <PeopleListModal
          onClose={() => setPeopleModalDisplayed(false)}
          socket={socket}
        />
      )}

      {projectModalDisplayed && (
        <ProjectListModal
          onClose={() => setProjectModalDisplayed(false)}
          socket={socket}
        />
      )}

      {isAlertTableModalVisible && (
        <IoTAlertTableModal
          onClose={() => setIsAlertTableModalVisible(false)}
        />
      )}
    </div>
  );
};

export default SideBar;
